import { useDispatch } from 'react-redux';
import { useSelector } from '@/store';
import { setDeprecatedMeasurementsTableModal } from 'src/slices/modals';
import ManualDataDetails from './ManualDataDetails';

const ManualDataDetailsAdapterModal = () => {
  const dispatch = useDispatch();
  const { deprecatedMeasurementsTableModal: modalState } = useSelector(
    (state) => state.modals_store,
  );

  const onClose = () => {
    dispatch(
      setDeprecatedMeasurementsTableModal({
        open: false,
      }),
    );
  };

  if (!modalState.open) return null;

  return (
    <ManualDataDetails
      show={modalState.open}
      handleClose={onClose}
      device={{
        id: modalState.deviceId,
        name: modalState.deviceId,
      }}
    />
  );
};

export default ManualDataDetailsAdapterModal;
